var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLateDelivery = function SvgLateDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 25 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "inherit",
    clipPath: "url(#late-delivery_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 6.5a5.5 5.5 0 1 0 11 0 5.5 5.5 0 0 0-11 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.152 6.652H6.5V4M14.5 11H16a1.5 1.5 0 0 1 1.5 1.5V17M7 19.5A1.5 1.5 0 0 1 5.5 18v-3M15.5 20a2 2 0 1 0 4 0 2 2 0 0 0-4 0M7.5 20a2 2 0 1 0 4 0 2 2 0 0 0-4 0M15.5 20h-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 13h2.615a2.41 2.41 0 0 1 2.41 2.41V20H19.5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "late-delivery_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h24v24H.5z"
  })))));
};
export default SvgLateDelivery;